import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

// Libs
import { fetchThemeList } from '@/api/fetchThemeList'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

// Types

export const useThemeList = () => {
  const router = useRouter()
  const { locale } = router
  const { data, isSuccess } = useQuery([QUERY_KEY.FETCH_THEME_LIST, { locale }], () => fetchThemeList())

  return { themeListData: data, isThemeListDataSuccess: isSuccess }
}
